import { Spin } from 'antd';
import { Content } from 'model/response';
import  { useEffect, useRef, useState } from 'react';
import PdfViewerComponent from '../PdfViewer/pdfViewer';
interface FormRenderContent {
    content?: Content;
    onData?: any;
    activeTabIndex?: any
}

const RenderContent = ({ content }: FormRenderContent) => {
    const [loading, setLoading] = useState(true);
    const iframeRef = useRef<HTMLIFrameElement | null>(null);
    const interval = useRef<number | undefined>();

    const clearCheckingInterval = () => {
        if (interval.current !== undefined) {
            clearInterval(interval.current);
        }
    };

    const onIframeLoaded = () => {
        clearCheckingInterval();
        setLoading(false);
    };

    const getIframeLink = () => {
        if (!content?.url) return ""
        if (content?.fileType === 'html') {
            return content?.url
        }
        return `https://docs.google.com/gview?url=${content.url}&embedded=true`
    }

    useEffect(() => {
        if (content && content?.fileType !== 'pdf') {
            interval.current = window.setInterval(() => {
                try {
                    console.log('load iframe doc')
                    if (iframeRef.current?.contentWindow?.document.body.innerHTML === '') {
                        iframeRef.current.src = getIframeLink();
                    }
                } catch (e) {
                    onIframeLoaded();
                }
            }, 4000);

            return clearCheckingInterval;
        }


    }, [content?.url]);

    switch (content?.format) {
        case 'AUDIO':
            return (
                <div className="mb-4">
                    {/* Phần audio player */}
                    <audio controls src={content.url} style={{ width: '100%' }} />
                    {/* Phần mô tả bên dưới */}
                    {content.transcriptText && (
                        <p className="mt-2 max-h-64 overflow-y-auto p-2 bg-gray-100 rounded">
                            {content.transcriptText}
                        </p>
                    )}
                </div>
            );
        case 'VIDEO':
            return (
                <div className="mb-4">
                    {/* Phần video player */}
                    <video controls className="w-full min-h-64" src={content.url} />
                    {/* Phần mô tả bên dưới */}
                    {content.transcriptText && (
                        <p className="mt-2 max-h-64 overflow-y-auto p-2 bg-gray-100 rounded">
                            {content.transcriptText}
                        </p>
                    )}
                </div>
            );
        case 'TEXT':
            return (
                content.url ? (
                    <div>
                        {loading && content?.fileType !== 'pdf' && (
                            <div
                                className='absolute inset-0 flex items-center justify-center bg-white bg-opacity-80 z-50 flex flex-col'
                            >
                                <Spin size="large"></Spin>
                                <p>Đang tải nội dung ...</p>
                            </div>
                        )}
                        {content?.fileType === 'pdf' ? (
                            <div>
                                <PdfViewerComponent pdfUrl={content?.url}></PdfViewerComponent>
                            </div>
                        ) : (
                            <iframe
                                ref={iframeRef}
                                src={getIframeLink()}
                                style={{
                                    width: '100%',
                                    height: '500px',
                                    border: 'none',
                                    maxHeight: '700px',
                                }}
                                allow="autoplay"
                                title="Document Viewer"
                                onLoad={onIframeLoaded}
                                loading="lazy"
                            />
                        )}

                    </div>
                ) : (
                    <div>Content URL is not available</div>
                )
            );
        default:
            return <div>Unsupported format</div>;
    }
};

export default RenderContent
